<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 4.06836C7.58579 4.06836 7.25 4.40415 7.25 4.81836V7.25H4.81836C4.40415 7.25 4.06836 7.58579 4.06836 8C4.06836 8.41421 4.40415 8.75 4.81836 8.75H7.25V11.1816C7.25016 11.5957 7.58589 11.9316 8 11.9316C8.41411 11.9316 8.74984 11.5957 8.75 11.1816V8.75H11.1816C11.5957 8.74984 11.9316 8.41411 11.9316 8C11.9316 7.58589 11.5957 7.25016 11.1816 7.25H8.75V4.81836C8.75 4.40415 8.41421 4.06836 8 4.06836Z"
    fill="currentColor"
  />
</svg>
